import { useRootStore } from '@hooks/useRootStore';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import RestaurantList from '../components/restaurant/RestaurantList';
import CityName from '../components/city/CityName';
import RestaurantListSkeleton from '../components/restaurant/skeleton/RestaurantListSkeleton';

interface RestaurantListPageProps {
}

const RestaurantListPage: React.FC<RestaurantListPageProps> = observer(({ }) => {
    const { restaurantOfferStore, cityStore } = useRootStore();
    const { getRestaurantsAsync, isRestaurantLoading } = restaurantOfferStore;

    useEffect(() => {
        getRestaurantsAsync();

        return () => { }
    }, []);

    return (
        <Box>
            <CityName cityStore={cityStore} />
            {isRestaurantLoading
                ? <RestaurantListSkeleton />
                : <RestaurantList restaurantOfferStore={restaurantOfferStore} />
            }
        </Box>
    )
})

export default RestaurantListPage;